<template>
    <div class="main-breadcrumb" v-if="breadcrumbList.length">
        <!-- {{breadcrumbList}} -->
        <span>当前位置：</span>
        <Breadcrumb>
            <BreadcrumbItem v-for="(item,index) in breadcrumbList" :key="index" :to="item.path">{{item.name}}</BreadcrumbItem>
        </Breadcrumb>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },

    computed: {
        breadcrumbList() {
            console.log(
                "breadcrumbList",
                this.$store.getters.getBreadcrumbList
            );
            return this.$store.getters.getBreadcrumbList;
        },
    },
};
</script>

<style>
.main-breadcrumb {
    padding: 20px 0 16px !important;
    display: flex;
    align-items: center;
    font-size: 15px !important;
}

.ivu-breadcrumb {
    font-size: 15px !important;
}

.ivu-breadcrumb-item-separator {
    color: #808695 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/MainBreadcrumb.vue